import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CheckboxGroup, CheckboxGroupProps } from '@sato/components';

export const HookFormCheckboxGroup = ({
  ...props
}: { name: string } & Omit<CheckboxGroupProps, 'value' | 'onChange'>) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <CheckboxGroup
          {...props}
          {...field}
          // TODO: CheckboxGroup causes an infinite render loop if value is undefined
          value={field.value ?? []}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
